import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { AuthContext } from '../../App'

const AdminLogin = () => {
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();

        const email = e.target.email.value;
        const password = e.target.password.value;

        try {
            const auth = getAuth();
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            authContext.setIsAuthenticated(true);

            navigate('/admin');
        } catch (error) {
            setError("Invalid email or password")
        }
    };

    const back = () => {
        navigate("/")
    };

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold mb-4">Admin Account Login</h2>
                {error && <p className='text-red-500 px-2 py-2'>{error}</p>}
                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <input name="email" type="email" placeholder="Email" className="w-full border p-2 rounded" />
                    </div>
                    <div className="mb-4">
                        <input name="password" type="password" placeholder="Password" className="w-full border p-2 rounded" />
                    </div>
                    <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded hover-bg-blue-600">Login</button>
                </form>
                <button
                    onClick={back}
                    className="bg-red-500 mt-6 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                >
                    Back
                </button>
            </div>
        </div>
    );
};

export default AdminLogin;
